import React, { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Box,
  Tab,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';

import { IRequestCompanyDocsInfo } from 'src/Types/module/UpdateRequest/RequestCompanyDocsInfo';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CompanyDocsIndex from './CompanyDocsIndex';

const RequestCompanyDocsInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyDocsInfo, setCompanyDocsInfo] = useState<
    IRequestCompanyDocsInfo[]
  >([]);
  const [value, setValue] = React.useState('pending');

  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/member/documents?status=${value}`
        );

        if (data.success) {
          setCompanyDocsInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Company Documents information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <CompanyDocsIndex
                  isLoading={isLoading}
                  companyDocsInfo={companyDocsInfo}
                />
              </TabPanel>
              <TabPanel value='approved'>
                <CompanyDocsIndex
                  isLoading={isLoading}
                  companyDocsInfo={companyDocsInfo}
                />
              </TabPanel>
              <TabPanel value='rejected'>
                <CompanyDocsIndex
                  isLoading={isLoading}
                  companyDocsInfo={companyDocsInfo}
                />
              </TabPanel>
              {/* <Box p={2}>
              <TablePagination
                component='div'
                count={companyInfo?.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page && page}
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 75, 100]}
              />
            </Box> */}
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestCompanyDocsInfo;
